const IconCircle = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='129'
      height='129'
      viewBox='0 0 129 129'>
      <circle
        cx='64.5' // Adjusted to fit inside viewBox
        cy='64.5'
        r='64'
        fill='none'
        stroke='#FFF'
        transform='none' // Removed or adjusted transform to keep circle visible
      />
    </svg>
  );
};

export default IconCircle;
